import React, { useState, useEffect } from "react";
import { Button, Col, Card, Row } from "react-bootstrap";
import _ from "lodash";
import ApiAmusementService from "../../../core/api/api.amusementService";
import { FormProvider, useForm, Controller } from "react-hook-form";
import Swal from "sweetalert2";
import SwalMessage from "../_Components/SwalMessage";
import ApiAmusementGroup from "../../../core/api/api.amusementGroup";
import ApiAmusementComplex from "../../../core/api/api.amusementComplex";
import SelectComponent from "../_Components/ReactSelectComponent";
import ApiRegion from "../../../core/api/api.region";

const CacheManager = () => {
  const [amusementServiceList, setAmusementServiceList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [amusementGroupList, setAmusementGroupList] = useState([]);
  const [amusementComplexList, setAmusementComplexList] = useState([]);

  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    getValues,
    setValue,
    watch,
  } = useForm({});
  const methods = { register, handleSubmit, control, formState: { errors, isSubmitting }, getValues, setValue, watch };
  const methods2 = useForm({});
  const methods3 = useForm({});

  useEffect(() => {
    (async () => {
      try {
        const amusementComplexes = await ApiAmusementComplex.getAll({ pageSize: 200, pageNumber: 1 });
        setAmusementComplexList(
          amusementComplexes.data,
          //amusementComplexes.data.map((amusementComplex) => ({ value: amusementComplex.id, label: amusementComplex.name })),
        );
        const amusementGroups = await ApiAmusementGroup.getAllGroups();
        setAmusementGroupList(
          amusementGroups.map((amusementGroup) => ({ value: amusementGroup.id, label: amusementGroup.title })),
        );
        const response = await ApiRegion.getAllCity();
        setCityList(response.map((city) => ({ value: city.id, label: city.name })));
        const apiData = await ApiAmusementService.getAllServices();
        if (!_.isEmpty(apiData)) {
          setAmusementServiceList(apiData);
          //var grouped = tools.groupByListBasketItem(apiData, "amusementGroupS");
          //let objDataListGroupby = [];
          //let itemLevel = [];
          // Object.keys(grouped).map((element) => {
          // itemLevel = [];
          //  let yy = grouped[element]?.map((item) => {
          // if (item.reserveDetails != "NULL") {
          //  itemLevel.push({
          //   value: item.id,
          //  label: item.name,
          //serviceId: JSON.parse(item.reserveDetails)?.Id,
          // });
          // }
          // });
          // objDataListGroupby.push({ label: element, options: itemLevel });
          // });

          //setgroupByAmuzmentService(objDataListGroupby);
        } else {
          setAmusementServiceList([]);
        }
      } catch (error) {
      } finally {
      }
    })();

    return () => { };
  }, []);
  const onSubmit = async (data) => {
    var services = [];
    if (data.orderServiceName?.length > 0) services = data.orderServiceName?.map((item) => item.value);

    Swal.fire({
      title: "عملیات حذف کش",
      text: "از حذف کش اطمینان دارید؟",
      icon: "question",
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: "بله",
      denyButtonText: "خیر",
      cancelButtonText: "انصراف",
      customClass: {
        actions: "my-actions",
        cancelButton: "order-1 right-gap btn btn-secondary ",
        confirmButton: "order-2 btn btn-success px-5",
        denyButton: "order-3 btn btn-danger px-5",
      },
      focusCancel: true
    }).then((result) => {
      if (result.isConfirmed) {
        //const onSubmit =  async () => {
        // try {

        var responsePromise = ApiAmusementService.getAmusementServiceCacheToken();

        responsePromise
          .then((response) => {
            if (response.succeeded == true) {
              // alert("response1.succeeded");
              const formData = new FormData();

              services.forEach((file, index) => {
                formData.append("service", services[index]);
              });

              //  formData.append(
              //      "Id",
              //      91
              //  );
              formData.append("Code", response.data);
              fetch(process.env.REACT_APP_PHOTOPATH_WEB + "/api/v1/amusementService/DeleteAmusementServiceCache", {
                method: "POST",
                body: formData, // تبدیل شیء JavaScript به رشته JSON
              })
                .then((res) => res.json())
                .then(
                  (result) => {
                    if (result.substring(0, 1) == 1) SwalMessage({ title: result.substring(2), iSsuccess: true });
                    else SwalMessage({ title: result.substring(2), iSsuccess: false });
                  },
                  (error) => {
                  },
                );
            }
          })
          .catch((error) => {
            // هندل کردن خطاها
          });

        // const response = ApiAmusementService.deleteCache({ id: item });
        // if(response.succeeded){alert("okk")}Succeeded = true
        // SwalMessage({ title: response.message, iSsuccess: response.succeeded });
        // SwalMessage({ title: "با موفقیت انجام شد.", iSsuccess: true });
        //     }
        // catch (error) {
        // }
        //}
      } else if (result.isDenied) {
        //Swal.fire('Changes are not saved', '', 'info')
      }
    });
  };
  const onSubmit2 = async (data) => {
    const cityId = _.toString(data?.cityId?.value);
    const groupId = _.toString(data?.groupId?.value);

    Swal.fire({
      title: "عملیات حذف کش",
      text: "از حذف کش اطمینان دارید؟",
      icon: "question",
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: "بله",
      denyButtonText: "خیر",
      cancelButtonText: "انصراف",
      customClass: {
        actions: "my-actions",
        cancelButton: "order-1 right-gap btn btn-secondary",
        confirmButton: "order-2 btn btn-success px-5",
        denyButton: "order-3 btn btn-danger px-5",
      },
      focusCancel: true
    }).then((result) => {
      if (result.isConfirmed) {
        //const onSubmit =  async () => {
        // try {

        var responsePromise = ApiAmusementService.getAmusementServiceCacheToken();

        responsePromise
          .then((response) => {
            if (response.succeeded == true) {
              const formData = new FormData();

              formData.append("cityId", cityId);
              formData.append("groupId", groupId);

              formData.append("Code", response.data);

              fetch(process.env.REACT_APP_PHOTOPATH_WEB + "/api/v1/amusementGroup/DeleteAmusementGroupCache", {
                method: "POST",
                body: formData, // تبدیل شیء JavaScript به رشته JSON
              })
                .then((res) => res.json())
                .then(
                  (result) => {
                    if (result.substring(0, 1) == 1) SwalMessage({ title: result.substring(2), iSsuccess: true });
                    else SwalMessage({ title: result.substring(2), iSsuccess: false });
                  },
                  (error) => {
                  },
                );
            }
          })
          .catch((error) => {
            // هندل کردن خطاها
          });

        // const response = ApiAmusementService.deleteCache({ id: item });
        // if(response.succeeded){alert("okk")}Succeeded = true
        // SwalMessage({ title: response.message, iSsuccess: response.succeeded });
        // SwalMessage({ title: "با موفقیت انجام شد.", iSsuccess: true });
        //     }
        // catch (error) {
        // }
        //}
      } else if (result.isDenied) {
        //Swal.fire('Changes are not saved', '', 'info')
      }
    });
  };
  const onSubmit3 = async (data) => {
    var services = [];
    if (data.amusementComplexName?.length > 0) services = data.amusementComplexName?.map((item) => item.value);

    Swal.fire({
      title: "عملیات حذف کش",
      text: "از حذف کش اطمینان دارید؟",
      icon: "question",
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: "بله",
      denyButtonText: "خیر",
      cancelButtonText: "انصراف",
      customClass: {
        actions: "my-actions",
        cancelButton: "order-1 right-gap btn btn-secondary ",
        confirmButton: "order-2 btn btn-success px-5",
        denyButton: "order-3 btn btn-danger px-5",
      },
      focusCancel: true
    }).then((result) => {
      if (result.isConfirmed) {
        var responsePromise = ApiAmusementComplex.getAmusementComplexCacheToken();
        responsePromise
          .then((response) => {
            if (response.succeeded == true) {
              const formData = new FormData();
              services.forEach((file, index) => {
                formData.append("service", services[index]);
              });
              formData.append("Code", response.data);
              fetch(process.env.REACT_APP_PHOTOPATH_WEB + "/api/v1/amusementComplex/DeleteAmusementComplexCache", {
                method: "POST",
                body: formData, // تبدیل شیء JavaScript به رشته JSON
              })
                .then((res) => res.json())
                .then(
                  (result) => {
                    if (result.substring(0, 1) == 1) SwalMessage({ title: result.substring(2), iSsuccess: true });
                    else SwalMessage({ title: result.substring(2), iSsuccess: false });
                  },
                  (error) => {
                  },
                );
            }
          })
          .catch((error) => {
            // هندل کردن خطاها
          });
      } else if (result.isDenied) {
      }
    });
  };
  const onSubmit4 = async (data) => {
    const cityId = _.toString(data?.amusementCityName?.value);

    Swal.fire({
      title: "عملیات حذف کش",
      text: "از حذف کش اطمینان دارید؟",
      icon: "question",
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: "بله",
      denyButtonText: "خیر",
      cancelButtonText: "انصراف",
      customClass: {
        actions: "my-actions",
        cancelButton: "order-1 right-gap btn btn-secondary ",
        confirmButton: "order-2 btn btn-success px-5",
        denyButton: "order-3 btn btn-danger px-5",
      },
      focusCancel: true
    }).then((result) => {
      if (result.isConfirmed) {
        var responsePromise = ApiAmusementService.getAmusementServiceCacheToken();
        responsePromise
          .then((response) => {
            if (response.succeeded == true) {
              const formData = new FormData();
              formData.append("cityId", cityId);

              formData.append("Code", response.data);
              fetch(process.env.REACT_APP_PHOTOPATH_WEB + "/api/v1/Home/DeleteHomePageCache", {
                method: "POST",
                body: formData, // تبدیل شیء JavaScript به رشته JSON
              })
                .then((res) => res.json())
                .then(
                  (result) => {
                    if (result.substring(0, 1) == 1) SwalMessage({ title: result.substring(2), iSsuccess: true });
                    else SwalMessage({ title: result.substring(2), iSsuccess: false });
                  },
                  (error) => {
                  },
                );
            }
          })
          .catch((error) => {
            // هندل کردن خطاها
          });
      } else if (result.isDenied) {
      }
    });
  }
  return (
    <div className={`card card-custom`}>
      <div className="card-header border-0 pt-5">
        <h3 className="card-title align-items-start flex-column">
          <span className="card-label font-weight-bolder text-dark"> حافظه پنهان</span>
          <span className="text-muted mt-3 font-weight-bold font-size-sm"> حذف حافظه پنهان</span>
        </h3>
        <div className="card-toolbar"></div>
      </div>

      {/*Start body */}

      <div className="card-body pt-3 ">
        <div className="border-top">
          <FormProvider {...methods}>
            <form id="form" onSubmit={methods.handleSubmit(onSubmit)} className="col-12">
              <Card className="mt-5">
                <Card.Header className="fw-bold bg-light py-3">حذف کش صفحه هر تفریح</Card.Header>
                <Card.Body>
                  <Row>
                    <Col xs="12" lg="6" xl="6" className="tb-reponsive px-2">
                      <Controller
                        name="orderServiceName"
                        control={control}
                        rules={{}}
                        render={({ field }) => (
                          <SelectComponent
                            className="mt-0"
                            placeholder="نام سرویس"
                            options={amusementServiceList?.map((item) => ({
                              value: item.id,
                              label: item.id + "-" + item.name,
                            }))}
                            field={field}
                            isMulti
                          />
                        )}
                      />
                    </Col>
                  </Row>
                  <Row className="mt-3">
                    <Col xs="12" lg="6" xl="6" className="tb-reponsive px-2 mt-3">
                      <Button className="w-100" variant="success" type="submit">
                        <i className="far fa-trash-alt text-small"></i>
                        حذف کش
                      </Button>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </form>
          </FormProvider>

          <FormProvider {...methods2}>
            <form id="form" onSubmit={methods2.handleSubmit(onSubmit2)} className="col-12">
              <Card className="mt-4">
                <Card.Header className="fw-bold bg-light py-3">حذف کش صفحه لیست تفریحات </Card.Header>
                <Card.Body>
                  <Row>
                    <Col xs="12" lg="6" xl="6" className="tb-reponsive px-2">
                      <Controller
                        name="cityId"
                        control={methods2.control}
                        render={({ field }) => (
                          <SelectComponent className="mt-0" placeholder="نام شهر" options={cityList} field={field} />
                        )}
                      />
                    </Col>
                  </Row>

                  <Row>
                    <Col xs="12" lg="6" xl="6" className="tb-reponsive px-2 mt-5 pt-3">
                      <Controller
                        name="groupId"
                        control={methods2.control}
                        rules={{}}
                        render={({ field }) => (
                          <SelectComponent
                            className="mt-0"
                            placeholder="عنوان دسته"
                            options={amusementGroupList}
                            field={field}
                          />
                        )}
                      />
                    </Col>
                  </Row>

                  <Row className="mt-3">
                    <Col xs="12" lg="6" xl="6" className="tb-reponsive px-2 mt-3">
                      <Button className="w-100" variant="success" type="submit">
                        <i className="far fa-trash-alt text-small"></i>
                        حذف کش
                      </Button>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </form>
          </FormProvider>
          {/* حذف کش برای مجتمع های تفریحی */}
          <FormProvider {...methods}>
            <form id="form" onSubmit={methods.handleSubmit(onSubmit3)} className="col-12">
              <Card className="mt-5">
                <Card.Header className="fw-bold bg-light py-3">حذف کش هر مجتمع</Card.Header>
                <Card.Body>
                  <Row>
                    <Col xs="12" lg="6" xl="6" className="tb-reponsive px-2">
                      <Controller
                        name="amusementComplexName"
                        control={control}
                        rules={{}}
                        render={({ field }) => (
                          <SelectComponent
                            className="mt-0"
                            placeholder="نام مجتمع"
                            options={amusementComplexList?.map((item) => ({
                              value: item.id,
                              label: item.id + "-" + item.name,
                            }))}
                            field={field}
                            isMulti
                          />
                        )}
                      />
                    </Col>
                  </Row>
                  <Row className="mt-3">
                    <Col xs="12" lg="6" xl="6" className="tb-reponsive px-2 mt-3">
                      <Button className="w-100" variant="success" type="submit">
                        <i className="far fa-trash-alt text-small"></i>
                        حذف کش
                      </Button>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </form>
          </FormProvider>

          {/* حذف کش برای صفحه اصلی */}
          <FormProvider {...methods3}>
            <form id="form" onSubmit={methods3.handleSubmit(onSubmit4)} className="col-12">
              <Card className="mt-5">
                <Card.Header className="fw-bold bg-light py-3">حذف کش صفحه اصلی</Card.Header>
                <Card.Body>
                  <Row>
                    <Col xs="12" lg="6" xl="6" className="tb-reponsive px-2">
                      <Controller
                        name="amusementCityName"
                        control={methods3.control}
                        rules={{}}
                        defaultValue={{
                          "value": 899,
                          "label": "کیش"
                        }}
                        render={({ field }) => (
                          <SelectComponent className="mt-0" placeholder="نام شهر" options={cityList} field={field} />
                        )}
                      />
                    </Col>
                  </Row>
                  <Row className="mt-3">
                    <Col xs="12" lg="6" xl="6" className="tb-reponsive px-2 mt-3">
                      <Button className="w-100" variant="success" type="submit">
                        <i className="far fa-trash-alt text-small"></i>
                        حذف کش
                      </Button>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </form>
          </FormProvider>
        </div>
      </div>
    </div>
  );
};

export default CacheManager;
